import { periodAPI } from 'api/period';
import { useMutation, useQueryClient } from 'react-query';
import { toast } from 'react-toastify';
import { locales } from 'utils/constants';
import { QUERY_KEY } from 'utils/enums';

export function useCreatePeriod() {
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: periodAPI.create,
    onSuccess: (data) => {
      queryClient.setQueryData(QUERY_KEY.FIND_ONE_PERIOD, data);
      toast(locales.createSuccess, { type: 'success' });
    },
  });

  return mutation;
}
